import { getColor } from '@theme-ui/color';

import type { ColorName } from '../colors';

import { useTheme } from './useTheme';

export function useColor(name: ColorName): string {
	return getColor(useTheme(), name) as string;
}
